import axios from "axios";
import { Base_URL } from "../url";

// Get all countries
export const getAllCountries = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CountryMaster/GetAllCountries`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching countries!";
  }
};

// Get regions by country
export const getRegionsByCountry = async (countryCode) => {
  try {
    const response = await axios.post(`${Base_URL}/RegionMaster/GetRegionsByCountry`, {
      countryCode: countryCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching regions!";
  }
};

// Create new district
export const createDistrict = async (districtData, userName = "11") => {
  try {
    const response = await axios.post(
      `${Base_URL}/DistrictMaster/CreateDistrict?UserName=${userName}`,
      districtData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating district!";
  }
};

// Get all districts
export const getAllDistricts = async () => {
  try {
    const response = await axios.get(`${Base_URL}/DistrictMaster/GetAllDistricts`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching districts!";
  }
};